/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Timecodes_TitleInputs */

const en_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group Timecodes`)
};

const fr_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codes temporels du groupe d’événements`)
};

const de_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes der Ereignisgruppen`)
};

const it_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codici temporali del gruppo di eventi`)
};

const ru_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Временные метки групп событий`)
};

const es_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de tiempo del grupo de eventos`)
};

const zh_cn2_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组时间码`)
};

const ja_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループのタイムコード`)
};

const hi_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप टाइमकोड`)
};

const pt_pt2_event_group_timecodes_title = /** @type {(inputs: Event_Group_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de tempo do grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Event Group Timecodes" |
*
* @param {Event_Group_Timecodes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_timecodes_title = /** @type {((inputs?: Event_Group_Timecodes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Timecodes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_timecodes_title(inputs)
	if (locale === "de") return de_event_group_timecodes_title(inputs)
	if (locale === "it") return it_event_group_timecodes_title(inputs)
	if (locale === "ru") return ru_event_group_timecodes_title(inputs)
	if (locale === "es") return es_event_group_timecodes_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_timecodes_title(inputs)
	if (locale === "ja") return ja_event_group_timecodes_title(inputs)
	if (locale === "hi") return hi_event_group_timecodes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_timecodes_title(inputs)
	return en_event_group_timecodes_title(inputs)
});